//Creates new GlassTube and assigns ID and type
export const createGlassTube = (data) => {
    //data = {id, type}
    return { type: "CREATE_GLASSTUBE", payload: data}
}


export const glassTubeItemDrop = (data) => {
    return { type: "GLASSTUBE_DROP_ITEM", payload: data}
}

export const glassTubeRemoveItem = (data) => {
    return { type: "GLASSTUBE_REMOVE_ITEM", payload: data}
}

export const setGlassTubepH = (data) => {
    return { type: "GLASSTUBE_SET_PH", payload: data}
}
